import React from 'react';
import styled from 'styled-components';
import { ColorNeutralWhite, Spacing16, Spacing24, Spacing32, Spacing56, Spacing64 } from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';
import Layout from 'components/Layout';
import { breakpoint, sizes } from 'variables';
import { getNumberOfItems, InventoryLaneList } from './index';
import type { InventoryLaneProps } from './shared/types';

const StyledSection = styled(Layout.Section)<{ noOfItemsMobile: number; noOfItemsDesktop: number }>`
    display: ${({ noOfItemsMobile }) => (noOfItemsMobile === 0 ? 'none' : 'grid')};

    ${breakpoint.up(sizes.sm)} {
        display: ${({ noOfItemsDesktop }) => (noOfItemsDesktop === 0 ? 'none' : 'grid')};
    }
`;

const StyledHeading = styled(Typography.Headline)`
    text-align: center;
`;

export default function InventoryLaneConnectedContent({ model }: { model: InventoryLaneProps }) {
    const { noOfItemsMobile, noOfItemsDesktop } = getNumberOfItems(model);

    if (!model.inventoryLaneBlocks?.length) return null;

    return (
        <StyledSection
            heading={model.inventoryLaneHeader}
            headingRenderer={(heading) => (heading ? <StyledHeading size="L">{heading}</StyledHeading> : null)}
            noOfItemsDesktop={noOfItemsDesktop}
            noOfItemsMobile={noOfItemsMobile}
        >
            <InventoryLaneList content={model} />
        </StyledSection>
    );
}
